import './GamesOldSearch.scss';
import { useEffect, useState } from 'react';

import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { ONBOARDING_CONFIG } from '../../features/onboarding/constants';
import { GamesOnboarding } from '../../features/onboarding/GamesOnboarding';
import { DEFAULT_LANGUAGE } from '../../i18n/constants';
import { getUserLanguage } from '../../i18n/helpers';
import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';
import { useTooltip } from '../Tooltip/useTooltip';

import { GamesCarousel } from './GamesCarousel';
import { GamesInfiniteCarousel } from './GamesInfiniteCarousel';
import { useGamesSeen } from './hooks/useGamesSeen';
import { useImpressionView } from './hooks/useImpressionView';
import GamesLoader from './Loader';
import { seenGamesLobbyListener } from './seenGamesImpression';
import Title from './TitleOldSearch';

export const Games = observer(() => {
  const { categoriesStore, onboardingStore, gamesSearchStore } = useStores();
  const { i18n } = useTranslation();
  const language = getUserLanguage(i18n.language);

  const { tooltipStyles, setReferenceElement, setPopperElement } = useTooltip('top', [-20, 20]);

  const [isTooltipReady, setIsTooltipReady] = useState(false);

  const showOnboarding = onboardingStore.step === ONBOARDING_CONFIG.START_GAME;

  const isInfiniteCarouselEnabled = useFlag('web_infinite_carousel', false);

  useImpressionView('home', 'all');
  useGamesSeen(seenGamesLobbyListener);

  useEffect(() => {
    setTimeout(() => {
      if (showOnboarding) {
        setIsTooltipReady(true);
      }
    }, 300);
  }, [showOnboarding]);

  if (categoriesStore.loading.get('categories')) {
    return <GamesLoader />;
  }

  return (
    <>
      {categoriesStore.categoriesIds
        .filter((id) => id !== gamesSearchStore.gameSubCategorySearchId)
        .map((id, idx) => {
          const category = categoriesStore.categoriesRegistry[id];
          if (!category || isEmpty(category.subCategoryGames)) {
            return null;
          }
          const { subCategoryGames: games } = category;
          const onboardingRow = showOnboarding && idx === 0;

          return (
            <div
              key={id}
              className={classNames('games', { games_onboarding: onboardingRow })}
              data-games-row={category.name[DEFAULT_LANGUAGE]}
              data-row-num={idx}
            >
              <Title
                imageUrl={category.imageUrl}
                name={category.name[language] || category.name[DEFAULT_LANGUAGE]}
                scImageUrl={category.scImageUrl}
              />
              {isInfiniteCarouselEnabled ? (
                <GamesInfiniteCarousel
                  id={id}
                  onboardingRow={onboardingRow}
                  setReferenceElement={setReferenceElement}
                />
              ) : (
                <GamesCarousel id={id} onboardingRow={onboardingRow} setReferenceElement={setReferenceElement} />
              )}
              {idx === 0 && showOnboarding && isTooltipReady && (
                <GamesOnboarding game={games[1]} setPopperElement={setPopperElement} tooltipStyles={tooltipStyles} />
              )}
            </div>
          );
        })}
    </>
  );
});
